import { GetterTree } from 'vuex'
import { TemplatesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<TemplatesState, RootState> = {
  templates:state => state.templates,
  multichannelTemplates:state => state.multichannelTemplates,
  templateItem:state => state.templateItem,

  allTemplates: state => state.allTemplates 
};